import * as React from 'react'

const ArrowContainer = ({
  position,
  targetRect,
  popoverRect,
  arrowSize = 10,
  style = {},
  arrowColor = 'black',
}) => (
  <div
    style={{
      position: 'absolute',
      ...(() => {
        const arrowWidth = arrowSize * 2
        let top =
          targetRect.top -
          popoverRect.top -
          window.pageYOffset +
          targetRect.height / 2 -
          arrowWidth / 2
        let left =
          targetRect.left -
          popoverRect.left -
          window.pageXOffset +
          targetRect.width / 2 -
          arrowWidth / 2
        left = left < 0 ? 0 : left
        left =
          left + arrowWidth > popoverRect.width
            ? popoverRect.width - arrowWidth
            : left
        top = top < 0 ? 0 : top
        top =
          top + arrowWidth > popoverRect.height
            ? popoverRect.height - arrowWidth
            : top
        switch (position) {
          case 'right':
            return {
              borderTop: `${arrowSize}px solid transparent`,
              borderBottom: `${arrowSize}px solid transparent`,
              borderRight: `${arrowSize}px solid ${arrowColor}`,
              left: -arrowSize,
              top,
            }
          case 'left':
            return {
              borderTop: `${arrowSize}px solid transparent`,
              borderBottom: `${arrowSize}px solid transparent`,
              borderLeft: `${arrowSize}px solid ${arrowColor}`,
              right: -arrowSize,
              top,
            }
          case 'bottom':
            return {
              borderLeft: `${arrowSize}px solid transparent`,
              borderRight: `${arrowSize}px solid transparent`,
              borderBottom: `${arrowSize}px solid ${arrowColor}`,
              top: -arrowSize,
              left,
            }
          case 'top':
          default:
            return {
              borderLeft: `${arrowSize}px solid transparent`,
              borderRight: `${arrowSize}px solid transparent`,
              borderTop: `${arrowSize}px solid ${arrowColor}`,
              bottom: -arrowSize,
              left,
            }
        }
      })(),
      ...style,
    }}
  />
)

export default ArrowContainer
